import { KEYCLOAK } from '@/config';
import { getKeycloakRealm } from '@/utils/hostUtils';

export const getKeycloakRestApiUrl = () => {
  const keycloakUrl = KEYCLOAK?.URL;
  const realm = getKeycloakRealm();

  return `${keycloakUrl}/admin/realms/${realm}`;
};
